import { render, staticRenderFns } from "./OnMigration.vue?vue&type=template&id=508acf78&scoped=true"
import script from "./OnMigration.vue?vue&type=script&lang=js"
export * from "./OnMigration.vue?vue&type=script&lang=js"
import style0 from "./OnMigration.vue?vue&type=style&index=0&id=508acf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508acf78",
  null
  
)

export default component.exports